export const environment: any = {
  production: false,
  projectUrl: 'https://dev.somosclientportal.com/',
  supabaseUrl: 'https://api.dev.somosclientportal.com/',
  supabaseKey:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlzcyI6InN1cGFiYXNlIiwiaWF0IjoxNzgwMzQxOTYwLCJleHAiOjE5MzgwMjE5NjB9.98S_1JNWun2SgFaAFQZiBcoTWKEukK02Jx_ZlC_oNIc',
  lambdaUrl: 'https://lambda.dev.somosclientportal.com',
  // lambdaUrl: 'http://localhost:3000',
  turnstileSiteKey: '0x4AAAAAAFDUyX0vm373xl1b',
};

// export const environment: any = {
//   production: false,
//   projectUrl: 'https://portal.portalirpa.com.br/',
//   supabaseUrl: 'https://api.prod.p1.somosclientportal.com/',
//   supabaseKey:
//     'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjogImFub24iLCJpc3MiOiAic3VwYWJhc2UiLCJpYXQiOiAxNzM5MjI0MTMzLCJleHAiOiAyMDU0NzU2OTMzfQ.ucoCcXOoQL9bLVBUmWo08qFpvyg0BkjfBVzUigP_vOQ',
//   lambdaUrl: 'https://lambda.prod.p1.somosclientportal.com/',
// };

// export const environment: any = {
//   production: false,
//   projectUrl: 'https://cp.prod.bonnyoilspill.somosclientportal.com/',
//   supabaseUrl: 'https://api.cp.prod.bonnyoilspill.somosclientportal.com/',
//   supabaseKey:
//     'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.ewogICAgInJvbGUiOiAiYW5vbiIsCiAgICAiaXNzIjogInN1cGFiYXNlIiwKICAgICJpYXQiOiAxNzIxOTYyODAwLAogICAgImV4cCI6IDE4Nzk3MjkyMDAKfQ.ez0WmzTLfapTTCiykGxjBQE4Sm_EIRkjgssa0SWxiMc',
//   lambdaUrl: 'https://lambda.cp.prod.bonnyoilspill.somosclientportal.com',
// };

// export const environment: any = {
//   production: false,
//   projectUrl: 'https://demo.somosclientportal.com/',
//   supabaseUrl: 'https://api.demo.somosclientportal.com/',
//   supabaseKey:
//     'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjogImFub24iLCJpc3MiOiAic3VwYWJhc2UiLCJpYXQiOiAxNzUwMTY1ODkzLCJleHAiOiAyMDY1Njk4NjkzfQ.WrTJ8XDLi1vbVTif8U06FZkbzzw-Idsva1KBqWg4Z1Y',
//   lambdaUrl: 'https://lambda.demo.somosclientportal.com',
// };
